import BaseAuth from 'nast-auth'

/**
 *
 */
export default class NastAuth extends BaseAuth {
  token(token = undefined) {
    if (token) {
      this._store.commit('auth/token', token)
    }
    return this._store.getters['auth/token']
  }
  static store(config = {}) {
    return {
      namespaced: true,
      state: {
        user: {},
        grants: {},
        token: '',
      },
      getters: {
        user: (state) => {
          return state.user
        },
        grants: (state) => {
          return state.grants
        },
        token: (state) => {
          return state.token
        },
      },
      mutations: {
        login(state, { user, token, grants, }) {
          state.user = user
          state.token = token
          state.grants = grants
          localStorage.setItem('auth', JSON.stringify({ user, token, grants, }))
        },
        logout(state) {
          state.user = {}
          state.token = ''
          state.grants = {}
          localStorage.removeItem('auth')
        },
        user(state, user) {
          state.user = user
          localStorage.setItem('auth', JSON.stringify({ user, token: state.token, grants: state.grants, }))
        },
        grants(state, grants) {
          state.grants = grants
          localStorage.setItem('auth', JSON.stringify({ user: state.user, token: state.token, grants, }))
        },
        token(state, token) {
          state.token = token
          localStorage.setItem('auth', JSON.stringify({ user: state.user, token: token, grants: state.grants, }))
        },
      },
    }
  }
}
